// climateCompliance.js
export const CODEBORD_HDD_BREAKS = [0, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000];
export const CODEBORD_RATIO_VALUES = [0.2, 0.3, 0.35, 0.4, 0.5, 0.55, 0.6, 0.65, 0.75];

/**
 * Returns the minimum required outboard/inboard ratio for CodeBord based on HDD.
 * If `hasLowPermCodebord` is false, returns 0 (not applicable), exactly like the sheet.
 */
export function requiredCodebordRatio(hdd, hasLowPermCodebord) {
  if (!hasLowPermCodebord) return 0;

  // emulate Excel LOOKUP: find last breakpoint <= hdd
  let idx = 0;
  for (let i = 0; i < CODEBORD_HDD_BREAKS.length; i += 1) {
    if (hdd >= CODEBORD_HDD_BREAKS[i]) idx = i;
    else break;
  }
  return CODEBORD_RATIO_VALUES[idx];
}
